import { getAuthorization, getStore } from 'controllers/controller';
import { updateAllNotificationAsSeenService } from 'services/notifications/updateAllNotificationAsSeen';

export const updateAllNotificationAsSeen = async () => {
  const authorization = getAuthorization();
  const uid = getStore().user.details.userId;

  await updateAllNotificationAsSeenService(authorization, uid);

  return true;
};
